<template>
    <div>
      <!-- Drawer抽屉 -->
      <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="50%" >
        <div :style="{maxHeight: maxHeight}" class="drawer-content">
          <Form ref="form" :model="form" :rules="formValidate"  label-position="top">
            <Row :gutter="16">
            
              <Col span="12">
                <FormItem label="供应商全称" prop="compName" >
                  <Input v-model="form.compName" clearable/>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="供应商简称" prop="shortName" >
                  <Input v-model="form.shortName" clearable/>
                </FormItem>
              </Col>
          
              <Col span="12">
                <FormItem label="联系人" prop="contractName" >
                  <Input v-model="form.contractName" clearable/>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="联系电话" prop="contractPhone" >
                  <Input v-model="form.contractPhone" clearable/>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="备注" prop="remark" >
                  <Input v-model="form.remark" type="textarea" :rows="4" maxlength="250" show-word-limit/>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
        <div class="drawer-footer br" style="text-align:right" slot="footer" v-show="type!='0'">
          <el-button  type="primary" :loading="submitLoading" @click="submit">提交</el-button>
          <el-button @click="visible = false">取消</el-button>
        </div>
      </el-dialog>






      
    </div>
  </template>
  
  <script>
  // 根据你的实际请求api.js位置路径修改
  import { addCompany, editCompany } from "@/api/index";
  export default {
    name: "addEdit",
    components: {
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object
      },
      type: {
        type: String,
        default: "0"
      }
    },
    data() {
      return {
        visible: this.value,
        title: "",
        submitLoading: false,
        maxHeight: 510,
        buildArray:[],
        form: { // 添加或编辑表单对象初始化数据
          buildId: "",
          compName: "",
          shortName: "",
          contractName: "",
          contractPhone: "",
        },
        // 表单验证规则
        formValidate: {
        compName: [{ type: "string", required: true, message: "请输入供应商名称", trigger: "blur" }],
      }
      };
    },
    methods: {
      init() {
      },
   
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            delete this.form.tvsCompanyUser
            if (this.type == "1") {
              // 编辑
              this.submitLoading = true;
              editCompany(this.form).then(res => {
                this.submitLoading = false;
                if (res.success) {
                  this.$Message.success("操作成功");
                  this.$emit("on-submit", true);
                  this.visible = false;
                }
              });
            } else {
              // 添加
              this.submitLoading = true;
              addCompany(this.form).then(res => {
                this.submitLoading = false;
                if (res.success) {
                  this.$Message.success("操作成功");
                  this.$emit("on-submit", true);
                  this.visible = false;
                }
              });
            }
          }
        });
      },
      setCurrentValue(value) {
        if (value === this.visible) {
          return;
        }
        if (this.type == "1") {
          this.title = "编辑";
          this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
        } else if (this.type == "2") {
          this.title = "添加";
          this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
        } else {
          this.title = "详细信息";
          this.maxHeight = "100%";
        }
        // 清空数据
        //this.$refs.form.resetFields();
        if (this.type == "0" || this.type == "1") {
          // 回显数据处理
          this.form = this.data;
          delete this.form.tvsCompanyUser
          delete this.form.tvsCompanyGoodNames
          delete this.form.goodItems
          delete this.form.unloadUser
          delete this.form.checkUser

        } else {
          // 添加
          this.form = {
          buildId: "",
          compName: "",
          shortName: "",
          contractName: "",
          contractPhone: "",
          }
        }
        this.visible = value;
      }
    },
    watch: {
      value(val) {
        this.setCurrentValue(val);
      },
      visible(value) {
        this.$emit("input", value);
       
      }
    },
    mounted() {
      this.init();
      


    }
  };
  </script>
  
  <style lang="less">
  @import "@/styles/drawer-common.less";
  </style>